module.exports = __webpack_public_path__ + "img/7_131.f7377367.png";